const CENTS_IN_DOLLAR = 100;

const getFormattedAmountValue = (value: number): number => {
  const amount = value / CENTS_IN_DOLLAR;

  return amount;
};

export default getFormattedAmountValue;
